module.exports = __webpack_public_path__ + "img/CTR.ccd10a36.svg";